import { Tooltip } from '../tooltip'
import { SummaryCardDivider } from './summary-card-divider'
import { SummaryCardShell } from './summary-card-shell'

export interface AuthorizedSessionsBreakdown {
  remaining: number
  total_credits: number
  has_overage: boolean
  psych_remaining: number | null
}

interface Props {
  breakdown: AuthorizedSessionsBreakdown
  variant?: 'elevated' | 'outlined'
}

const OVERAGE_TOOLTIP =
  'There are more therapy and psychiatry appointments than authorized. These will be reviewed by clinical leadership.'

export function AuthorizedSessionsCard({ breakdown, variant }: Props) {
  return (
    <SummaryCardShell variant={variant} className="flex-col gap-2">
      <div className="flex items-start justify-between gap-4">
        <p className="text-sm font-semibold leading-6 text-charcoal-75">
          Authorized Sessions Remaining
        </p>
        {breakdown.has_overage && (
          <Tooltip text={OVERAGE_TOOLTIP}>
            <i
              className="fa-solid fa-circle-exclamation cursor-help text-brick-light"
              role="img"
              aria-label={OVERAGE_TOOLTIP}
            />
          </Tooltip>
        )}
      </div>

      <div className="flex items-stretch gap-4">
        <ValueCell value={breakdown.remaining} label="Therapy" />
        {breakdown.psych_remaining !== null && (
          <>
            <SummaryCardDivider />
            <ValueCell value={breakdown.psych_remaining} label="Psychiatry" />
          </>
        )}
      </div>
    </SummaryCardShell>
  )
}

function ValueCell({ value, label }: { value: number; label: string }) {
  return (
    <div className="flex min-w-[110px] items-baseline gap-2">
      <span className="text-[28px] font-bold leading-[1.5] text-charcoal-75">{value}</span>
      <span className="text-sm font-medium text-charcoal-75">{label}</span>
    </div>
  )
}
